import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  clientId: string | null = null;
  returnUrl: string | null = null;

  constructor(
    private router: Router,
    private authService: AuthService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
  ) {
    this.route.queryParams.subscribe((params) => {
      const code = params['code'];
      const state = params['state'];
      const returnUrl = params['returnUrl'];
      this.returnUrl = returnUrl ?? null;

      if (!this.clientId && returnUrl) {
        const url = new URL(returnUrl);
        this.clientId = url.searchParams.get('client_id');
      }

      if (
        this.clientId == null ||
        this.clientId == undefined ||
        this.clientId == ''
      )
        this.clientId = this.authService.getClienteIdLocal();

      if (this.clientId) this.authService.setClienteIdLocal(this.clientId);

      if (code && state) {
        this.spinner.show();
        this.authService.exchangeCodeForToken(code, state).subscribe({
          next: (response) => {
            const redirectUrl = response.redirectUrl;
            if (
              redirectUrl &&
              this.authService.isTrustedRedirect(redirectUrl)
            ) {
              this.spinner.hide();
              window.location.assign(redirectUrl);
            } else {
              console.error('URL de redirecionamento não encontrada');
              this.spinner.hide();
            }
          },
          error: (err) => {
            console.error('Erro ao trocar código por token:', err);
            this.spinner.hide();
          },
        });
      }
    });
  }

  goTo(path: string) {
    this.router.navigate([path], {
      queryParams: this.returnUrl ? { returnUrl: this.returnUrl } : undefined,
    });
  }

  loginWithGoogle() {
    if (!this.returnUrl) {
      alert(
        'Contexto SSO invalido. Inicie o login pelo sistema que deseja acessar.',
      );
      return;
    }

    window.location.assign(this.authService.getGoogleLoginUrl(this.returnUrl));
  }
}
